module.exports={
  "AL": {
    "key": "AL",
    "name": "Alabama",
    "ap": "Ala.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 9
  },
  "AK": {
    "key": "AK",
    "name": "Alaska",
    "ap": "Alaska",
    "closingTime": "1 a.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 3,
    "district-unused22": "",
    "geo_offset_x": -5,
    "geo_offset_y": -15
  },
  "AZ": {
    "key": "AZ",
    "name": "Arizona",
    "ap": "Ariz.",
    "closingTime": "9 p.m.",
    "rating-unused22": "toss-up",
    "electoral-unused22": 11,
    "district-unused22": "",
    "geo_offset_x": 3
  },
  "AR": {
    "key": "AR",
    "name": "Arkansas",
    "ap": "Ark.",
    "closingTime": "8:30 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 6,
    "district-unused22": "",
    "geo_offset_x": -5
  },
  "CA": {
    "key": "CA",
    "name": "California",
    "ap": "Calif.",
    "closingTime": "11 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 55,
    "district-unused22": "",
    "geo_offset_x": -20
  },
  "CO": {
    "key": "CO",
    "name": "Colorado",
    "ap": "Colo.",
    "closingTime": "9 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 9
  },
  "CT": {
    "key": "CT",
    "name": "Connecticut",
    "ap": "Conn.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 7,
    "district-unused22": "",
    "geo_offset_x": 765,
    "geo_offset_y": 270
  },
  "DC": {
    "key": "DC",
    "name": "District of Columbia",
    "ap": "D.C.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 3,
    "district-unused22": "",
    "geo_offset_x": 765,
    "geo_offset_y": 360
  },
  "DE": {
    "key": "DE",
    "name": "Delaware",
    "ap": "Del.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 3,
    "district-unused22": "",
    "geo_offset_x": 765,
    "geo_offset_y": 420
  },
  "FL": {
    "key": "FL",
    "name": "Florida",
    "ap": "Fla.",
    "closingTime": "8 p.m.",
    "rating-unused22": "toss-up",
    "electoral-unused22": 29,
    "district-unused22": "",
    "geo_offset_x": 40
  },
  "GA": {
    "key": "GA",
    "name": "Georgia",
    "ap": "Ga.",
    "closingTime": "7 p.m.",
    "rating-unused22": "toss-up",
    "electoral-unused22": 16,
    "district-unused22": "",
    "geo_offset_x": -3
  },
  "HI": {
    "key": "HI",
    "name": "Hawaii",
    "ap": "Hawaii",
    "closingTime": "12 a.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 4,
    "district-unused22": "",
    "geo_offset_x": -5,
    "geo_offset_y": 10
  },
  "ID": {
    "key": "ID",
    "name": "Idaho",
    "ap": "Idaho",
    "closingTime": "11 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 4,
    "district-unused22": "",
    "geo_offset_x": "",
    "geo_offset_y": 30
  },
  "IL": {
    "key": "IL",
    "name": "Illinois",
    "ap": "Ill.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 20,
    "district-unused22": "",
    "geo_offset_x": 5,
    "geo_offset_y": -5
  },
  "IN": {
    "key": "IN",
    "name": "Indiana",
    "ap": "Ind.",
    "closingTime": "7 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 11,
    "district-unused22": "",
    "geo_offset_x": "",
    "geo_offset_y": -2
  },
  "IA": {
    "key": "IA",
    "name": "Iowa",
    "ap": "Iowa",
    "closingTime": "10 p.m.",
    "rating-unused22": "lean-r",
    "electoral-unused22": 6
  },
  "KS": {
    "key": "KS",
    "name": "Kansas",
    "ap": "Kan.",
    "closingTime": "9 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 6
  },
  "KY": {
    "key": "KY",
    "name": "Kentucky",
    "ap": "Ky.",
    "closingTime": "7 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 8,
    "district-unused22": "",
    "geo_offset_x": 15,
    "geo_offset_y": -2
  },
  "LA": {
    "key": "LA",
    "name": "Louisiana",
    "ap": "La.",
    "closingTime": "9 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 8,
    "district-unused22": "",
    "geo_offset_x": -17,
    "geo_offset_y": -10
  },
  "ME": {
    "key": "ME",
    "name": "Maine",
    "ap": "Maine",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 2
  },
  "MD": {
    "key": "MD",
    "name": "Maryland",
    "ap": "Md.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 10,
    "district-unused22": "",
    "geo_offset_x": 765,
    "geo_offset_y": 390
  },
  "MA": {
    "key": "MA",
    "name": "Massachusetts",
    "ap": "Mass.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 11,
    "district-unused22": "",
    "geo_offset_x": 765,
    "geo_offset_y": 240
  },
  "MI": {
    "key": "MI",
    "name": "Michigan",
    "ap": "Mich.",
    "closingTime": "9 p.m.",
    "rating-unused22": "lean-d",
    "electoral-unused22": 16,
    "district-unused22": "",
    "geo_offset_x": 25,
    "geo_offset_y": 35
  },
  "MN": {
    "key": "MN",
    "name": "Minnesota",
    "ap": "Minn.",
    "closingTime": "9 p.m.",
    "rating-unused22": "lean-d",
    "electoral-unused22": 10,
    "district-unused22": "",
    "geo_offset_x": -15
  },
  "MS": {
    "key": "MS",
    "name": "Mississippi",
    "ap": "Miss.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 6
  },
  "MO": {
    "key": "MO",
    "name": "Missouri",
    "ap": "Mo.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 10,
    "district-unused22": "",
    "geo_offset_x": -5
  },
  "MT": {
    "key": "MT",
    "name": "Montana",
    "ap": "Mont.",
    "closingTime": "10 p.m.",
    "rating-unused22": "lean-r",
    "electoral-unused22": 3
  },
  "NE": {
    "key": "NE",
    "name": "Nebraska",
    "ap": "Neb.",
    "closingTime": "9 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 2
  },
  "NV": {
    "key": "NV",
    "name": "Nevada",
    "ap": "Nev.",
    "closingTime": "10 p.m.",
    "rating-unused22": "lean-d",
    "electoral-unused22": 6,
    "district-unused22": "",
    "geo_offset_x": "",
    "geo_offset_y": -10
  },
  "NH": {
    "key": "NH",
    "name": "New Hampshire",
    "ap": "N.H.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 4,
    "district-unused22": "",
    "geo_offset_x": 765,
    "geo_offset_y": 210
  },
  "NJ": {
    "key": "NJ",
    "name": "New Jersey",
    "ap": "N.J.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 14,
    "district-unused22": "",
    "geo_offset_x": 765,
    "geo_offset_y": 330
  },
  "NM": {
    "key": "NM",
    "name": "New Mexico",
    "ap": "N.M.",
    "closingTime": "9 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 5
  },
  "NY": {
    "key": "NY",
    "name": "New York",
    "ap": "N.Y.",
    "closingTime": "9 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 29,
    "district-unused22": "",
    "geo_offset_x": 5,
    "geo_offset_y": -2
  },
  "NC": {
    "key": "NC",
    "name": "North Carolina",
    "ap": "N.C.",
    "closingTime": "7:30 p.m.",
    "rating-unused22": "toss-up",
    "electoral-unused22": 15,
    "district-unused22": "",
    "geo_offset_x": 22,
    "geo_offset_y": -2
  },
  "ND": {
    "key": "ND",
    "name": "North Dakota",
    "ap": "N.D.",
    "closingTime": "9 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 3
  },
  "OH": {
    "key": "OH",
    "name": "Ohio",
    "ap": "Ohio",
    "closingTime": "7:30 p.m.",
    "rating-unused22": "toss-up",
    "electoral-unused22": 18
  },
  "OK": {
    "key": "OK",
    "name": "Oklahoma",
    "ap": "Okla.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 7,
    "district-unused22": "",
    "geo_offset_x": 18,
    "geo_offset_y": -2
  },
  "OR": {
    "key": "OR",
    "name": "Oregon",
    "ap": "Ore.",
    "closingTime": "11 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 7,
    "district-unused22": "",
    "geo_offset_x": "",
    "geo_offset_y": 5
  },
  "PA": {
    "key": "PA",
    "name": "Pennsylvania",
    "ap": "Pa.",
    "closingTime": "8 p.m.",
    "rating-unused22": "lean-d",
    "electoral-unused22": 20,
    "district-unused22": "",
    "geo_offset_x": "",
    "geo_offset_y": -2
  },
  "RI": {
    "key": "RI",
    "name": "Rhode Island",
    "ap": "R.I.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 4,
    "district-unused22": "",
    "geo_offset_x": 765,
    "geo_offset_y": 300
  },
  "SC": {
    "key": "SC",
    "name": "South Carolina",
    "ap": "S.C.",
    "closingTime": "7 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 9,
    "district-unused22": "",
    "geo_offset_x": 5,
    "geo_offset_y": -5
  },
  "SD": {
    "key": "SD",
    "name": "South Dakota",
    "ap": "S.D.",
    "closingTime": "9 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 3,
    "district-unused22": "",
    "geo_offset_x": "",
    "geo_offset_y": -5
  },
  "TN": {
    "key": "TN",
    "name": "Tennessee",
    "ap": "Tenn.",
    "closingTime": "8 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 11
  },
  "TX": {
    "key": "TX",
    "name": "Texas",
    "ap": "Texas",
    "closingTime": "9 p.m.",
    "rating-unused22": "toss-up",
    "electoral-unused22": 38,
    "district-unused22": "",
    "geo_offset_x": 20
  },
  "UT": {
    "key": "UT",
    "name": "Utah",
    "ap": "Utah",
    "closingTime": "10 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 6
  },
  "VT": {
    "key": "VT",
    "name": "Vermont",
    "ap": "Vt.",
    "closingTime": "7 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 3,
    "district-unused22": "",
    "geo_offset_x": 765,
    "geo_offset_y": 180
  },
  "VA": {
    "key": "VA",
    "name": "Virginia",
    "ap": "Va.",
    "closingTime": "7 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 13,
    "district-unused22": "",
    "geo_offset_x": 15
  },
  "WA": {
    "key": "WA",
    "name": "Washington",
    "ap": "Wash.",
    "closingTime": "11 p.m.",
    "rating-unused22": "likely-d",
    "electoral-unused22": 12
  },
  "WV": {
    "key": "WV",
    "name": "West Virginia",
    "ap": "W.Va.",
    "closingTime": "7:30 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 5,
    "district-unused22": "",
    "geo_offset_x": -8,
    "geo_offset_y": 5
  },
  "WI": {
    "key": "WI",
    "name": "Wisconsin",
    "ap": "Wis.",
    "closingTime": "9 p.m.",
    "rating-unused22": "toss-up",
    "electoral-unused22": 10
  },
  "WY": {
    "key": "WY",
    "name": "Wyoming",
    "ap": "Wyo.",
    "closingTime": "9 p.m.",
    "rating-unused22": "likely-r",
    "electoral-unused22": 3
  }
}